import { WidgetCard } from '@/components/common/WidgetCard';
import { useRecentActivity } from '@/features/dashboard/hooks/useDashboard';
import { formatRelative } from '@/lib/format';
import { cn } from '@/lib/cn';
import { DocumentTextIcon } from '@/icons';

const dotFor = (sev?: string) =>
  sev === 'critical' ? 'bg-danger' : sev === 'warning' ? 'bg-warning' : 'bg-brand';

/** Recent activity feed from the audit service. */
export function RecentActivityWidget() {
  const { data, isLoading, isError, refetch } = useRecentActivity();

  return (
    <WidgetCard title="Recent Activity" icon={DocumentTextIcon} isLoading={isLoading} isError={isError} onRetry={refetch}>
      {data && data.length === 0 ? (
        <p className="py-6 text-center text-sm text-fg-subtle">No recent activity.</p>
      ) : (
        <ul className="space-y-3">
          {(data ?? []).map((item) => (
            <li key={item.id} className="flex gap-3">
              <span className={cn('mt-1.5 h-2 w-2 shrink-0 rounded-full', dotFor(item.severity))} aria-hidden="true" />
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm text-fg">
                  <span className="font-medium">{item.actor}</span>{' '}
                  <span className="text-fg-muted">{item.action}</span>
                  {item.target && <span className="text-fg"> {item.target}</span>}
                </p>
                <p className="text-xs text-fg-subtle">{formatRelative(item.timestamp)}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </WidgetCard>
  );
}
